/**
     * WorkflowCompleted.contract.ts — Event Contract System™ (generation v1).
     * A core orchestration workflow finished (success or failure — published in finally).
     */

    import type { EventContract } from '../EventContractRegistry';

    export const WorkflowCompletedContract: EventContract = {
      name: 'WorkflowCompleted',
      version: 1,
      description: "A core orchestration workflow finished (success or failure — published in finally).",
      publishers: ["core"],
      subscribers: ["dev-center:live-feed"],
      fields: [
        { name: 'workflow', type: 'string', required: true, description: "Workflow identifier (e.g. locationChanged)" },
    { name: 'locationId', type: 'string', required: false, description: "Base involved, when location-scoped" },
      ],
      allowExtraFields: false,
      timestampPolicy: "Workflow time (now) at completion.",
      stability: 'stable',
      deprecated: false,
      example: {"workflow":"locationChanged","locationId":"lisbon"},
    };
    